import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
        
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/campaign-player/details"}
                            objectKeys={["id","campaign.name", "player_currency.player.id", "player_currency.player.operator_user_id", "player_currency.player.operator_id", "player_currency.currency.iso_code", "contribution_booster", "eligible"]}
                            columnTitles={[
                                "ID", "Campaign Name", "Player ID", "Operator Player ID", "Operator ID", "Currency", "Contribution Booster", "Eligible"
                            ]}
                            //"Campaign Name", "Player ID", "Operator Player Id", "Currency",
                            pageTitle={"Campaign Players"}
                            readEndpoint={"campaign-player-currency/read"}
                            relations={["campaign", "player_currency.player", "player_currency.currency"]}
                            />
        </>
    )
}

export default CampaignListPage;